import React from "react";
import { Home, Bot, MessageCircle, Utensils } from "lucide-react";
import { translations } from "@/i18n";

const ITEMS = [
  { key: "dashboard", icon: Home },
  { key: "ai", icon: Bot },
  { key: "operator", icon: MessageCircle },
  { key: "menu", icon: Utensils },
];

export const BottomNav = ({ page, navigate, lang }) => {
  const T = translations[lang];
  return (
    <div
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] bg-white shadow-[0_-4px_20px_rgba(26,26,46,0.06)] px-2 pt-1.5 pb-safe flex justify-around items-stretch z-40 border-t border-[#F0F7FF]"
    >
      {ITEMS.map(({ key, icon: Icon }) => {
        const active = page === key;
        return (
          <button
            key={key}
            data-testid={`nav-${key}`}
            onClick={() => navigate(key)}
            className="flex flex-col items-center justify-center py-1.5 min-w-[60px] min-h-[48px] transition-transform duration-200 active:scale-95"
          >
            <Icon size={24} strokeWidth={active ? 2.4 : 1.9} className={active ? "text-[#4AADDF]" : "text-[#6B7B8D]"} />
            <span className={`text-[11px] mt-0.5 font-medium ${active ? "text-[#4AADDF]" : "text-[#6B7B8D]"}`}>
              {T.nav[key]}
            </span>
          </button>
        );
      })}
    </div>
  );
};
